import Services from "../../services/Services";
const services = new Services(null) as any;

// toast actions
import {
  dismiss,
  update,
  error,
  message,
  warning,
  success,
  info,
} from "react-toastify-redux";

// dispatch(dismiss(id));
// dispatch(dismiss()); // dismiss all toasts
// dispatch(update(id, options));
//   dispatch(message("Default message"));
//   dispatch(success("Success message"));
//   dispatch(error("Error message"));
//   dispatch(warning("Warning message"));
//   dispatch(info("Info message"));

const GET_ASSESSMENTS = "schoolDataCenter/getInstitutionAssessments";
const TOGGLE_LOADER = "schoolDataCenter/toggleLoader";
const GET_USERTYPE_ASSESSMENTS = "schoolDataCenter/getUserTypeAssessments";
const GET_CURRENT_PROFILE = "schoolDataCenter/getInstitutionProfile";
const GET_YEAR_GROUPS = "schoolDataCenter/getInstitutionYearGroups";
const GET_DEPARTMENTS = "schoolDataCenter/getInstitutionDepartments";
const GET_COHORTS = "schoolDataCenter/getCohortsList";
const GET_COHORTS_DATA = "schoolDataCenter/getCohortsListFiltered";
const GET_CURRENT_ASSESSMENT_STATS = "schoolDataCenter/getCurrentAssessmentStats";
const GET_ALERT_LEVELS_BREAKDOWN = "schoolDataCenter/getAlertLevelsBreakdown";
const UPDATE_QUERY_ARRAY = "schoolDataCenter/updateQueryArray";

const INITIAL_STATE = {
  assessments: [],
  breakdown: [],
  cohorts: [],  
  selectCohorts: [],
  currentAssessmentStats: {},
  currentProfile: {},
  yearGroups: [],
  departments: [],
  loaded: true,
  cohortsLoaded: false,
  selectedCohort: null,
  selectedAssessment: null,
  assessmentsLoaded: false,
  currentUserType: "",
  queryArray: [],

  // UI Togglers
  showAssessmentPicker: false,
};

export default (state = INITIAL_STATE, action) => {
  const { type, payload } = action;

  switch (type) {
    case TOGGLE_LOADER: 
        return {
            ...state,
            loaded: payload
        }

    case GET_ASSESSMENTS:
      return {
        ...state,
        assessments: payload,
      };

    case GET_USERTYPE_ASSESSMENTS:
      return {
        ...INITIAL_STATE,
        assessments: payload.assessments,
        currentUserType: payload.usertype,
        currentProfile: state.currentProfile,
        showAssessmentPicker: true,
      };

    case GET_COHORTS:
      return {
        ...state,
        cohorts: payload.cohorts,
        selectCohorts: payload.cohorts,
        selectedAssessment: payload.assessmentId,
        cohortsLoaded: true,
      };

    case GET_COHORTS_DATA:
      return {
        ...state,
        cohorts: payload,
      };

    case GET_CURRENT_ASSESSMENT_STATS:
      return {
        ...state,
        currentAssessmentStats: payload.data,
        assessmentsLoaded: true,
        loaded: true,
        selectedCohort: payload.cohort,
        queryArray: payload.clearFilters ? [] : state.queryArray
      };

    case GET_ALERT_LEVELS_BREAKDOWN:
      return {
        ...state,
        breakdown: payload,
      };

    case GET_CURRENT_PROFILE:
      return {
        ...state,
        currentProfile: payload,
      };

    case GET_YEAR_GROUPS:
      return {
        ...state,
        yearGroups: payload,
      };

    case GET_DEPARTMENTS:
      return {
        ...state,
        departments: payload,
      };

    case UPDATE_QUERY_ARRAY:
      return {
        ...state,
        queryArray: payload,
      };

    default:
      return state;
  }
};

export const toggleLoader = (loaded) => dispatch => {
    dispatch({type: TOGGLE_LOADER, payload: loaded })
}

export const getInstitutionAssessments = (id) => async (dispatch) => {
  const res = await services.institutionsAPI.getInstitutionsAssessments(id);
  if (res.ok) {
    dispatch({ type: GET_ASSESSMENTS, payload: res.data.assessments });
  } else {
    dispatch(error("Unable to fetch assessments at this time"));
  }
};

export const getUserTypeAssessments = (id, usertype) => async (dispatch) => {
    dispatch(toggleLoader(false));
  const res = await services.institutionsAPI.getUserTypeAssessmentList(
    id,
    usertype
  );
  if (res.ok) {
      if(!res.data.assessments.length) {dispatch(warning("These users do not have any assessments yet")); return;}
    dispatch({
      type: GET_USERTYPE_ASSESSMENTS,
      payload: { assessments: res.data.assessments, usertype },
    });
  } else {
    dispatch(error("Unable to fetch assessments at this time"));
  }
  dispatch(toggleLoader(true));
};

export const getCurrentProfile = (id) => async (dispatch) => {
  const res = await services.institutionsAPI.getInstitutionsProfile(id);
  if (res.ok) {
    dispatch({ type: GET_CURRENT_PROFILE, payload: res.data.profile });
  }
};

export const getCohortsList = (id, assessmentId) => async (dispatch) => {
  const res = await services.institutionsAPI.getCohortsList(id, assessmentId);
  if (res.ok) {
    dispatch({ type: GET_COHORTS, payload: {cohorts: res.data.cohorts, assessmentId} });
    dispatch(getInstitutionDepartments(id));
    dispatch(getInstitutionYearGroups(id));
  }
};


export const getCohortsListFiltered = (id, assessmentId, query) => async (dispatch) => {
  const res = await services.institutionsAPI.getCohortData(id, assessmentId, query);
  if (res.ok) {
    dispatch({ type: GET_COHORTS_DATA, payload: res.data.cohorts });

  }
};

export const getInstitutionYearGroups = (id) => async (dispatch) => {
  const res = await services.institutionsAPI.getInstitutionYearGroups(id);
  if (res.ok) {
    dispatch({ type: GET_YEAR_GROUPS, payload: res.data.year_groups });
  }
};

export const getInstitutionDepartments = (id) => async (dispatch) => {
  const res = await services.institutionsAPI.getInstitutionDepartments(id);
  if (res.ok) {
    dispatch({ type: GET_DEPARTMENTS, payload: res.data.departments });
  }
};

export const getCurrentAssessmentStats = (userId, assessment, cohort, usertype, query, clearFilters = false) => async (dispatch) => {
    const res = await services.institutionsAPI.getInstitutionsOverallAssessmentDataFiltered(userId, assessment, cohort, usertype, query);
    if(res.ok) {
        dispatch({ type: GET_CURRENT_ASSESSMENT_STATS, payload: {data: res.data, cohort, clearFilters } });
    }
};

export const getAlertLevelsBreakdown = (userId, assessment, cohort, query) => async (dispatch) => {
    const res = await services.institutionsAPI.getInstitutionAssessmentLevelsBreakdownFiltered(userId, assessment, cohort, query);
    if(res.ok) {
        dispatch({ type: GET_ALERT_LEVELS_BREAKDOWN, payload: res.data.levels });
    }
};

export const updateQueryArray = (arr) => (dispatch) => {
    dispatch({ type:UPDATE_QUERY_ARRAY, payload: arr});
}




// WEBPACK FOOTER //
// ./src/redux/ducks/schoolDataCenter.ts